import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { emptyCart, getCartItems, placeNewOrder, verifyDeliveryLocation } from "../../../store/actions/user/User";
import StripeCheckout from "../Cart/StripeCheckout";
import PlacesWithStandaloneSearchBox from "../Home/map";

const useStyles = makeStyles((theme) => ({
    addressFormContainer: {
        width: "100%",
    },
    locationError: {
        marginLeft: "20px"
    },
}));

const CheckoutForm = ({ cart, placeNewOrder, handleSideBar, getCartItems, emptyCart, verifyDeliveryLocation, handleAddressSave, addressSaved, userDetails }) => {
    const classes = useStyles();
    const [address, updateAddress] = useState({
        phone_number: userDetails ? userDetails.phone_number : '',
        building_number: "",
        zipCodeNotAvailable: false,
    });

    const [checkoutAddress, updateCheckoutAddress] = useState({});
    const [openCardDetails, updateCardDetails] = useState(false);
    const [errorDelivery, updateErrorDelivery] = useState("");
    const [phone_number, updatePhone] = useState(userDetails ? userDetails.phone_number : '');
    const [proceed, updateProceed] = useState(true);
    const locationRef = React.createRef();

    useEffect(() => {
        if (address?.phone_number && address?.phone_number !== "" && address?.building_number !== "") {
            updateProceed(false);
        } else {
            updateProceed(true);
        }

    }, [address?.phone_number, address?.building_number]);



    useEffect(() => {
        if (userDetails && userDetails.phone_number) {
            updatePhone(userDetails.phone_number)
            const tempAddress = { ...address };
            tempAddress['phone_number'] = userDetails.phone_number;
            updateAddress(tempAddress);
        }
    }, [userDetails])

    const handleChange = (e) => {
        const tempAddress = { ...address };
        tempAddress[e.target.id] = e.target.value;
        updateAddress(tempAddress);
    };

    const handleAdressChange = (value, obj) => {
        const tempAddress = { ...address };
        tempAddress['address'] = obj;
        updateAddress(tempAddress);
    }

    const renderLocationInput = () => {
        return (
            <PlacesWithStandaloneSearchBox
                location={locationRef}
                isCheckout={true}
            ></PlacesWithStandaloneSearchBox>
        );
    };

    const renderPayment = () => {
        return <StripeCheckout handlePayment={proceedToPayment} />;
    };

    const handleOnContinue = () => {
        const pincode = localStorage.getItem("pincode");
        const city = localStorage.getItem("city");
        const state = localStorage.getItem("state");
        const country = localStorage.getItem("country");
        const street = localStorage.getItem("street");
        const lat = localStorage.getItem("latitude");
        const lng = localStorage.getItem("longitude");
        const totalPrice = localStorage.getItem("totalCost");
        verifyDeliveryLocation({ pincode: pincode }).then(resp => {
            if (resp?.status === 1) {
                if (address.phone_number !== "" && address.building_number !== "" && city && city.length > 0) {
                    const payload = {
                        vendorId: cart[0]?.vendorId,
                        address: {
                            building_number: address.building_number,
                            street: street,
                            city: city,
                            state: state,
                            country: country,
                            pincode: pincode,
                            latitude: lat,
                            longitude: lng,
                            phone_number: phone_number
                        },
                        totalPrice: totalPrice?.toString(),
                        payment_token: "",
                    };
                    updateCheckoutAddress(payload);
                    handleAddressSave(payload);
                } else {
                    updateErrorDelivery('Invalid Location, please change the location and try again');
                }
            } else {
                updateErrorDelivery(resp?.message);
            }
        })
    };

    const proceedToPayment = (token) => {
        const tempPayload = { ...checkoutAddress };
        tempPayload.payment_token = token?.id;
        placeNewOrder(tempPayload).then(async (data) => {
            await emptyCart();
            await getCartItems()
            handleSideBar();
        }).catch(err => {
            handleSideBar();
        })
    };

    return (
        <>
            {addressSaved ? (
                // renderPayment()

                < div className={classes.addressFormContainer}>
                    <div className="checkout-form" action="" style={{ padding: "25px", alignItems: 'flex-start' }}>
                        <div>
                            <h4>
                                {localStorage.getItem('street')}
                            </h4>
                            <p style={{ marginBottom: '7px' }}>
                                Building Number : {address.building_number}
                            </p>
                            <p>
                                Phone Number : {phone_number}
                            </p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={classes.addressFormContainer}>
                    <div className="checkout-form" action="" style={{ padding: "25px" }}>
                        <br></br>
                        <div className="row address-inputs">
                            <div className={`col-md-12 ${classes.location}`}>
                                {renderLocationInput()}
                                {
                                    errorDelivery &&
                                    <div className={classes.locationError}>
                                        <span>
                                            <p style={{ color: "red", fontSize: "small" }}>
                                                {errorDelivery}
                                            </p>
                                        </span>
                                    </div>
                                }
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    placeholder="Building Number"
                                    id="building_number"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    type="text"
                                    placeholder="Phone no."
                                    id="phone_number"
                                    required
                                    value={phone_number}
                                    onChange={(e) => {
                                        updatePhone(e.target.value)
                                        handleChange(e)
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-around" }}>
                            <button
                                className="site-btn btnAdd submit-order-btn"
                                style={{ color: proceed ? "black" : "white", background: proceed ? "#ffffff" : "rgb(1, 160, 90)" }}
                                disabled={proceed}
                                onClick={handleOnContinue}
                            >
                                Proceed To Checkout
              </button>
                        </div>
                    </div>
                </div>
            )
            }
        </>
    );
};

const mapStateToProps = (state) => ({
    cart: state.user.cart,
});

const mapDispatchToProps = (dispatch) => ({
    placeNewOrder: (checkout) => dispatch(placeNewOrder(checkout)),
    getCartItems: () => dispatch(getCartItems()),
    emptyCart: () => dispatch(emptyCart()),
    verifyDeliveryLocation: (data) => dispatch(verifyDeliveryLocation(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
